var map = {
	"./patent_image0.png": "1612",
	"./patent_image1.png": "3d23",
	"./patent_image10.png": "77ad",
	"./patent_image11.png": "d722",
	"./patent_image12.png": "2684",
	"./patent_image13.png": "daa3",
	"./patent_image14.png": "7e7e",
	"./patent_image15.png": "7e52",
	"./patent_image16.png": "fb45",
	"./patent_image2.png": "ddd2",
	"./patent_image3.png": "abec",
	"./patent_image4.png": "f58e",
	"./patent_image5.png": "7ee3",
	"./patent_image6.png": "f7f7",
	"./patent_image7.png": "c4b7",
	"./patent_image8.png": "4dc2",
	"./patent_image9.png": "5e14"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aca6";